import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { IOrgStageCoordsGetterOutput } from '../functions/getOrgStages-1'
import RootStoreContext from '../../../storage/RootStore'
import {D3Rect} from '../../D3Components/D3Rect'
import { colors, constants } from '../../../Constants'
import { getStageInfo, getStagesForOrg } from '../../../dict/STAGES'

/// functions
/// types
/// components

interface ChartHeaderProps extends IOrgStageCoordsGetterOutput { }

export const ChartHeader: React.FC<ChartHeaderProps> = observer(({
    orgStagesCoords, arrayOrgNodes, connectionDotsCoords, arrayStages
}) => {
    const { selection } = useContext(RootStoreContext)
    const { BLOCK, HIGHLIGHT_LINE } = constants;

    return (<g>
        {arrayStages && arrayStages.map((stageID, stageIndex) => {

            /// When clicked on stage or stage-org dot
            const selected = selection.stage === stageID

            /// When clicked on org - highlightin stage
            const connected = getStagesForOrg(selection.org).includes(stageID) && !selection.orgStage



            // Colors
            const bgColor = (stageIndex + 1) % 2 === 0 ? 'rgba(25,25,125,0.15)' : 'rgba(25,25,125,0.075)'
            const fillColor = (
                selected ? constants.BLOCK.COLOR_SELECTED_LABEL : 
                connected ? constants.BLOCK.COLOR_SELECTED :
                bgColor
            )
  

            const {stageName, stageDesc} = getStageInfo(stageID)

            return stageIndex === 0 ? null : (
                <D3Rect
                    key={`header-${stageID}`}
                    x={stageIndex * BLOCK.WIDTH}
                    y={0}
                    width={BLOCK.WIDTH}
                    height={BLOCK.HEIGHT}
                    labelAlign={'center'}
                    cursor={stageIndex > 0 ? "pointer" : "auto"}
                    rectColor={fillColor}
                    rectBorderColor={`transparent`}
                    children={<text style={{color: selected ? 'white':'black', fontWeight: 500}}>{stageName}</text>}
                    onClick={() => stageIndex > 0 ? selection.setStage(stageID) : null}
                />
            )
        })}
    </g>)
})
